// CTAButton.js
import React from "react";
import "./CTAButton.css";
import { FaWhatsapp } from "react-icons/fa";

const CTAButton = () => {
  const whatsappLink = "https://wa.me/5516935006397";

  return (
    <a
      href={whatsappLink}
      className="cta-button"
      target="_blank"
      rel="noreferrer"
      aria-label="Fale com a nossa equipe pelo Whatsapp"
    >
      Fale com a nossa equipe
      <FaWhatsapp className="whatsapp-icon-cta" />
    </a>
  );
};

export default CTAButton;
